import COUNTRIES from '../countries.translations'

import type { Metal } from './types'
import translations from './zinc.content'

const t = translations
const dir = '/mine-my-phone/images/metals/zinc'

export const zinc: Metal = {
  id: 17,
  slug: 'zinc',
  name: t.name,
  symbol: 'Zn',
  mines: [
    {
      name: "Rampura Agucha (India, Hindustan Zinc — world's largest zinc mine)",
      region: t.mine0Region,
      slug: 'rampura-agucha',
      coordinates: [74.65, 25.05],
    },
    {
      name: 'Red Dog (USA, Teck, Alaska)',
      region: t.mine1Region,
      slug: 'red-dog',
      coordinates: [-162.88, 68.08],
    },
    {
      name: 'Mount Isa & McArthur River (Australia, Glencore)',
      region: t.mine2Region,
      slug: 'mount-isa-mcarthur-river',
      coordinates: [139.5, -20.73],
    },
    {
      name: 'Antamina (Peru)',
      region: t.mine3Region,
      slug: 'antamina',
      coordinates: [-77.06, -9.53],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 33.3 },
    { name: COUNTRIES.peru, percent: 10.8 },
    { name: COUNTRIES.australia, percent: 9.2 },
    { name: COUNTRIES.unitedStates, percent: 6.3 },
    { name: COUNTRIES.mexico, percent: 5.8 },
  ],
  // Indium is recovered as a by-product of zinc smelting.
  related: ['indium'],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'horizontal',
          credit: 'Bloomberg / Getty',
        },
      ],
      secondBento: [
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'CFOTO / Getty',
        },
      ],
    },
  },
}
